import type { HandCraftedModule } from '../components/slides/types'

/**
 * Registry of hand-crafted slide modules.
 * Each module exports { meta, slides } typed against HandCraftedModule.
 * These bypass MDX and archetype components entirely (ADR-0018).
 */
export const handCraftedModules: Record<string, () => Promise<HandCraftedModule>> = {
  /* ── All Crews ── */
  'all-crews-safety-basics': () => import('./all-crews-safety-basics'),

  /* ── Audio ── */
  // Orientation
  'welcome-to-the-audio-operations-crew': () =>
    import('./welcome-to-the-audio-operations-crew'),
  'welcome-to-the-audio-installation-crew': () =>
    import('./welcome-to-the-audio-installation-crew'),

  // Foundation
  'audio-operations-crew-overview': () => import('./audio-operations-crew-overview'),
  'audio-installation-system-design': () => import('./audio-installation-system-design'),
  'audio-operations-microphones-wireless': () =>
    import('./audio-operations-microphones-wireless'),

  // Installation Core
  'audio-installation-speaker-placement': () =>
    import('./audio-installation-speaker-placement'),
  'audio-installation-signal-infrastructure': () =>
    import('./audio-installation-signal-infrastructure'),

  // Operations Core
  'audio-operations-mixer-basics': () => import('./audio-operations-mixer-basics'),
  'audio-operations-monitor-mixing': () => import('./audio-operations-monitor-mixing'),
  'audio-operations-system-setup': () => import('./audio-operations-system-setup'),
  'audio-operations-troubleshooting': () => import('./audio-operations-troubleshooting'),
  'audio-operations-recording-streaming': () =>
    import('./audio-operations-recording-streaming'),

  // Kickoffs
  'audio-installation-kickoff': () => import('./audio-installation-kickoff'),
  'audio-operations-kickoff': () => import('./audio-operations-kickoff'),

  /* ── Video ── */
  // Orientation
  'welcome-to-the-video-operations-crew': () =>
    import('./welcome-to-the-video-operations-crew'),
  'welcome-to-the-video-installation-crew': () =>
    import('./welcome-to-the-video-installation-crew'),

  // Foundation
  'video-operations-crew-overview': () => import('./video-operations-crew-overview'),
  'video-operations-convention-program': () => import('./video-operations-convention-program'),

  // Installation
  'video-installation-camera-mounting': () => import('./video-installation-camera-mounting'),

  // Core
  'video-operations-shot-types-and-framing': () =>
    import('./video-operations-shot-types-and-framing'),
  'video-operations-walkthroughs': () => import('./video-operations-walkthroughs'),
  'video-operations-program-flow': () => import('./video-operations-program-flow'),
  'video-operations-troubleshooting': () => import('./video-operations-troubleshooting'),

  // Per-role mastery
  'video-operations-technical-director': () => import('./video-operations-technical-director'),
  'video-operations-switcher-operation': () => import('./video-operations-switcher-operation'),
  'video-operations-camera-operation': () => import('./video-operations-camera-operation'),
  'video-operations-media-playback': () => import('./video-operations-media-playback'),

  // Advanced
  'video-operations-leadership': () => import('./video-operations-leadership'),

  // Kickoffs
  'video-operations-kickoff': () => import('./video-operations-kickoff'),
  'video-installation-kickoff': () => import('./video-installation-kickoff'),

  /* ── Stage ── */
  // Orientation
  'welcome-to-the-stage-operations-crew': () =>
    import('./welcome-to-the-stage-operations-crew'),

  // Foundation
  'stage-operations-crew-overview': () => import('./stage-operations-crew-overview'),
  'stage-operations-convention-program': () =>
    import('./stage-operations-convention-program'),

  // Core
  'stage-operations-mic-handling': () => import('./stage-operations-mic-handling'),
  'stage-operations-furniture-props': () => import('./stage-operations-furniture-props'),
  'stage-operations-participant-guidance': () =>
    import('./stage-operations-participant-guidance'),
  'stage-operations-complex-scenarios': () =>
    import('./stage-operations-complex-scenarios'),

  // Advanced
  'stage-operations-leadership': () => import('./stage-operations-leadership'),

  // Kickoff
  'stage-operations-kickoff': () => import('./stage-operations-kickoff'),
}
